import React from "react";
import { useViewport } from "@bookingcom/bui-react";
import useSegment from "./useSegment.js";
import { OriginDestinationHorizontal } from "../OriginDestination/index.js";
import { DateDropDown } from "../Date/index.js";
import RemoveSegment from "./RemoveSegment.js";
import { OccupancyButtonDropDown } from "../Occupancy/index.js";
import styles from "./SegmentHorizontal.module.css";
const SegmentHorizontal = () => {
    const { isMultiStop, segments, isResponsiveFixes } = useSegment();
    const { isLarge } = useViewport();
    const isResponsiveFixesNotMultiStop = !isMultiStop && !isLarge && isResponsiveFixes;
    const isResponsiveFixesMultiStop = isMultiStop && !isLarge && isResponsiveFixes;
    return (React.createElement("div", { className: styles.wrapper }, segments.map((_, idx) => {
        const segmentContent = (React.createElement("div", { className: `${styles.line} ${isResponsiveFixesNotMultiStop ? styles.lineVertical : ""} ${isResponsiveFixesMultiStop ? styles.lineVerticalMultiStop : ""}`, "data-ui-name": "segments_list_item", style: {
                gridTemplateColumns: isMultiStop
                    ? "5fr 2fr"
                    : "minmax(0, 1fr) minmax(250px, max-content) minmax(150px, max-content)"
            } },
            React.createElement("div", { className: `${styles.destination} ${isResponsiveFixesMultiStop ? styles.destinationVertical : ""}` },
                React.createElement(OriginDestinationHorizontal, { segmentIndex: idx })),
            React.createElement("div", { className: `${styles.date} ${isResponsiveFixesMultiStop ? styles.dateVertical : ""}` },
                React.createElement(DateDropDown, { segmentIndex: idx })),
            !isMultiStop ? React.createElement(OccupancyButtonDropDown, null) : undefined,
            isMultiStop ? (React.createElement("div", { className: `${styles.remove} ${isResponsiveFixesMultiStop ? styles.removeVertical : ""}` },
                React.createElement(RemoveSegment, { disabled: segments.length === 1, segmentIndex: idx }))) : null));
        return isMultiStop ? React.createElement("fieldset", { key: idx }, segmentContent) : React.createElement("div", { key: idx }, segmentContent);
    })));
};
export default SegmentHorizontal;
